import React from "react";
import { Link, useLocation } from "react-router-dom";
import {
  Book,
  Wand2,
  Blocks,
  LayoutTemplate,
  Code2,
  FileJson,
} from "lucide-react";

const navItems = [
  {
    path: "/docs/getting-started",
    label: "Getting Started",
    icon: Book,
  },
  {
    path: "/docs/ai-generation",
    label: "AI Generation",
    icon: Wand2,
  },
  {
    path: "/docs/block-types",
    label: "Block Types",
    icon: Blocks,
  },
  {
    path: "/docs/templates",
    label: "Templates",
    icon: LayoutTemplate,
  },
  {
    path: "/docs/api-reference",
    label: "API Reference",
    icon: Code2,
  },
  {
    path: "/docs/pattern-format",
    label: "Pattern Format",
    icon: FileJson,
  },
];

export function DocsNavigation() {
  const location = useLocation();

  return (
    <nav className="space-y-1" aria-label="Documentation navigation">
      {navItems.map(({ path, label, icon: Icon }) => (
        <Link
          key={path}
          to={path}
          className={`flex items-center px-4 py-2 text-sm font-medium rounded-lg transition-colors ${
            location.pathname === path
              ? "bg-blue-500/20 text-doc-heading"
              : "text-doc-text hover:text-doc-heading hover:bg-blue-500/10"
          }`}
          aria-current={location.pathname === path ? "page" : undefined}
        >
          <Icon className="h-5 w-5 mr-3" aria-hidden="true" />
          {label}
        </Link>
      ))}
    </nav>
  );
}
